import { Theme } from '@mui/material/styles'

import { onHover, onHoverOverTint } from '../interaction'

// ----------------------------------------------------------------------

export default function Menu(theme: Theme) {
  return {
    MuiMenu: {
      styleOverrides: {
        root: {
          zIndex: 2000000001,
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          ...onHover({ backgroundColor: theme.palette.action.hover }),
          /**
           * The cream `action.selected` tint marks a selected list row, where
           * the checked checkbox is a second, redundant cue. A menu item has
           * no second cue — it IS the selection state — so the faint cream
           * disappears against a white dropdown. Use the neutral fill plus
           * medium weight instead, and keep hover visibly distinct from it.
           */
          '&.Mui-selected': {
            backgroundColor: theme.palette.background.neutral,
            fontWeight: theme.typography.fontWeightMedium,
            ...onHoverOverTint(theme, theme.palette.background.neutral),
          },
        },
      },
    },
  }
}
